// const { log } = require("console");

// const { log } = require("console");

console.log('template-product.js loaded');

const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),
    goatMilkBtns:document.querySelectorAll('[data-goatmilk]'),
    saferChoiceBtn: document.querySelector('[data-safer-choice-certification]'),
    addToCartCTA : document.querySelector('.pdp-btn'),
    stickyCTA : document.querySelector('.addtocart-container')
  };

  if( document.querySelector("[data-upsell-exist]") != null){
    document.querySelector("[show-text]").classList.remove("d-none");
}




	
	setTimeout(() => {
		//console.log('11', document.querySelector('.yotpo-main-widget'));
		if(document.querySelector('.yotpo-main-widget') != null) {
			//console.log('22', document.querySelector('.yotpo-main-widget .reviews-amount'),  document.querySelectorAll('.yotpo-main-widget .yotpo-user-name'));
			if(document.querySelector('.yotpo-main-widget .reviews-amount') != null) {
				document.querySelector('.yotpo-main-widget .reviews-amount').removeAttribute('aria-level');
			}
            //label-with-tooltip
            if(document.querySelectorAll('.yotpo-main-widget .yotpo-user-name') != null) {
                document.querySelectorAll('.yotpo-main-widget .yotpo-user-name').forEach(name => {
                    name.removeAttribute('aria-level');
                });
            }
            if(document.querySelectorAll('.yotpo-main-widget .label-with-tooltip') != null) {
                document.querySelectorAll('.yotpo-main-widget .label-with-tooltip').forEach(name => {
                    name.removeAttribute('aria-level');
                });
            }
            if(document.querySelectorAll('.yotpo-main-widget .yotpo-user-title') != null) {
                document.querySelectorAll('.yotpo-main-widget .yotpo-user-title').forEach(name => {
                    name.setAttribute('aria-level', '4');
                });
            }
            if(document.querySelector('.yotpo-main-widget .yotpo-pager[role="menu"]') != null) {
                document.querySelector('.yotpo-main-widget .yotpo-pager[role="menu"]').setAttribute('aria-busy', 'true');
            }
            if(document.querySelector('.yotpo-main-widget .write-question-review-buttons-container') != null) {
                document.querySelector('.yotpo-main-widget .write-question-review-buttons-container').setAttribute('role', 'tablist');
            }
            setTimeout(() => {
                if(document.querySelectorAll('.yotpo-main-widget .yotpo-dropdown-button span') != null) {
                    document.querySelectorAll('.yotpo-main-widget .yotpo-dropdown-button span').forEach(span => {
                        span.removeAttribute('role');
                    });
                }
            }, 500);
		}
        
        function yoptoPagination() {
           // console.log('test', document.querySelectorAll(".yotpo-page-element"));
            document.querySelectorAll(".yotpo-page-element").forEach(page => {
                page.addEventListener("click", removeAttibutes);
            });
        }
        yoptoPagination();
        function removeAttibutes() {
           // console.log('click');
            setTimeout(() => {
              if(document.querySelector('.yotpo-main-widget') != null) {
                 if(document.querySelector('.yotpo-main-widget .reviews-amount') != null) {
                      document.querySelector('.yotpo-main-widget .reviews-amount').removeAttribute('aria-level');
                  }
                  if(document.querySelectorAll('.yotpo-main-widget .yotpo-user-name') != null) {
                      document.querySelectorAll('.yotpo-main-widget .yotpo-user-name').forEach(name => {
                          name.removeAttribute('aria-level');
                      });
                  }
                  if(document.querySelectorAll('.yotpo-main-widget .label-with-tooltip') != null) {
                      document.querySelectorAll('.yotpo-main-widget .label-with-tooltip').forEach(name => {
                          name.removeAttribute('aria-level');
                      });
                  }
                  if(document.querySelectorAll('.yotpo-main-widget .yotpo-user-title') != null) {
                    document.querySelectorAll('.yotpo-main-widget .yotpo-user-title').forEach(name => {
                        name.setAttribute('aria-level', '4');
                    });
                  }
                  if(document.querySelector('.yotpo-main-widget .yotpo-pager[role="menu"]') != null) {
                    document.querySelector('.yotpo-main-widget .yotpo-pager[role="menu"]').setAttribute('aria-busy', 'true');
                  }
                  yoptoPagination();
              }
           }, 700);
        }
	  }, 1000);

   




  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class templateProductJS {
    constructor() {
        let test = document.querySelector('[aria-label="Subscription details"]');
        if(selectors.reviewratingEle){
            selectors.reviewratingEle.addEventListener('click', (event)=>{
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if(reviewSection) reviewSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            });
        }

        selectors.zoomBtns.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });
        selectors.goatMilkBtns.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                let currentTarget = event.target;
                this.manageGoatMilkInfo(currentTarget);
            })
        });
        selectors.saferChoiceBtn?.addEventListener('click', (event)=>{  
          this.manageSaferChoiceInfo(event.target)
        })
        
        this.stickyCheckout();
    }
    manageSaferChoiceInfo(currentTarget) {
      const saferChoiceDisclaimer = document.getElementById('safer-choice-disclaimer')
      if(saferChoiceDisclaimer) {
        saferChoiceDisclaimer.show();
      }
    }
    manageGoatMilkInfo(currentTarget){
        const zoomContainer = document.getElementById('PopupModal-goatmilk');
        if(zoomContainer){
            zoomContainer.show();
        }
    }
    manageVariantSlider(variant){
        const productJSON = window.globalVariables.product;
        const productSliderType = selectors.productContainer.dataset.slider_type;

        if(productSliderType == 'color-based' && productJSON.options && productJSON.options.includes('Color') || productJSON.options.includes('color') || productJSON.options.includes('COLOR')){
            const currentVariant = variant || window.globalVariables.product.currentVariant;
            const colorName = currentVariant.option1.toLowerCase();
            const colorMedia = [];
            mediaJSON.forEach(media => {
                let mediaAlt = media.alt;
                if(mediaAlt) mediaAlt = mediaAlt.toLowerCase();
                if(mediaAlt == colorName) colorMedia.push(media);
            });
            window.productMedia = colorMedia;

            if(window.globalVariables.templateSuffix == 'layout2'){
                const imagesParent = document.querySelector('[data-productImagesContainer]');
                if(!imagesParent || colorMedia.length <= 0) return;
                let slidesHTML = '';
                colorMedia.forEach(function(i,v){
                    let imageAlt = i.alt.toLowerCase();
                    if(imageAlt == colorName){
                        if(i.media_type == "external_video"){
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else if(i.media_type == "video"){
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else{
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                            <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });
                imagesParent.innerHTML= slidesHTML;
            }else{
                const thumbParent = document.querySelector('[data-thumbSlider]');
                const sliderParent = document.querySelector('[data-main-slider]');

                if(!thumbParent || !sliderParent || colorMedia.length <= 0) return;

                let thumbnailsHTML = '';
                let slidesHTML = '';
                colorMedia.forEach(function(i,v){
                    let imageAlt = i.alt.toLowerCase();
                    if(imageAlt == colorName){
                        if(i.media_type == "external_video"){
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else if(i.media_type == "video"){
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else{
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });

                let navDirection = thumbParent.dataset.direction || 'horizontal';
                let finalnavHTML = `
                    <div class="swiper-slider product-thumbnails" role="tree"
                            data-slider='{
                                "direction": "${navDirection}",
                                "loop": false,
                                "slidesPerView": "6",
                                "spaceBetween": 15,
                                "grabCursor": true,
                                "slideToClickedSlide": true
                            }' >
                        <div class="swiper-wrapper">${thumbnailsHTML}</div>
                    </div>`;
                thumbParent.innerHTML= finalnavHTML;

                let finalHTML = `<slider-element class="swiper-container carousel">
                                    <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails"
                                        data-slider='{
                                                "loop": false,
                                                "slidesPerView": "1",
                                                "spaceBetween": 15,
                                                "grabCursor": true,
                                                "navigation": {
                                                    "nextEl": ".swiper-button-next",
                                                    "prevEl": ".swiper-button-prev"
                                                },
                                                "pagination": {
                                                    "el": ".swiper-pagination"
                                                }
                                            }' role="tree">
                                        <div class="swiper-wrapper" >${slidesHTML}</div>
                                        <div class="swiper-pagination"></div>
                                    </div>
                                </slider-element>`;
                sliderParent.innerHTML= finalHTML;
            }

            selectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
            selectors.zoomBtns.forEach((btn)=>{
                btn.addEventListener('click', (event)=>{
                    let currentTarget = event.target;
                    this.manageZoom(currentTarget);
                })
            });
        }
    }

    manageZoom(currentTarget){
        let currentSlide = currentTarget.closest('.product--media');
        let currentSlideIndex = 1;
        if(currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);

        let zoomSlider = '';
        window.productMedia.forEach(i => {
            if(i.media_type == "external_video"){
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn" data-aos="hero">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            }else if(i.media_type == "video"){
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            }else if(i.media_type == "image"){
                zoomSlider+= `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <img class="img-fluid"
                    src="${i.preview_image.src}"
                    alt="${i.alt}"/>
                </div>`;
            }
        });
        let finalHTML = `<slider-element class="swiper-container carousel">
            <div class="swiper swiper-slider zoom--product-images"
                data-slider='{
                        "loop": false,
                        "observer": true,
                        "observeParents": true,
                        "slidesPerView": "1",
                        "spaceBetween": 15,
                        "grabCursor": true,
                        "navigation": {
                            "nextEl": ".swiper-button-next",
                            "prevEl": ".swiper-button-prev"
                        },
                        "pagination": {
                            "el": ".swiper-pagination"
                        }
                    }' role="tree">
                <div class="swiper-wrapper" >${zoomSlider}</div>
                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev icon-previous"></div>
                <div class="swiper-button-next icon-next"></div>

            </div>
        </slider-element>`;

        const zoomContainer = document.getElementById('PopupModal-zoom');
        if(zoomContainer){
            zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
            zoomContainer.show();
            if(productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        }
    }

     stickyCheckout() {

                    const div1 =  document.querySelector('.customFormProduct')
                    const div2 = document.querySelector('.addtocart-container');

                    function checkDiv1Position() {
                    const rect = div1.getBoundingClientRect();

                    if (rect.bottom < 0) {
                        // div1 is above the viewport
                        div2.classList.add('sticky-btn');
                    } else {
                        // div1 is in or below the viewport
                        div2.classList.remove('sticky-btn');
                    }
                    }

                    window.addEventListener('scroll', checkDiv1Position);
                    window.addEventListener('resize', checkDiv1Position);
                    document.addEventListener('DOMContentLoaded', checkDiv1Position);
        // window.onscroll = () => {
        //     const button = document.querySelector('.product__inventory');
        //     const stickyTarget = selectors.stickyCTA;
    
        //     if (!button || !stickyTarget) return;
            
        //     const buttonRect = button.getBoundingClientRect();
        //     const isVisible = buttonRect.top >= 0 && buttonRect.bottom <= window.innerHeight;
        //     console.log('buttonRecttop', buttonRect.top, buttonRect.bottom, window.innerHeight, isVisible);
    
        //     if (!isVisible && !stickyTarget.classList.contains('sticky-btn')) {
        //         console.log('Adding sticky-btn class', buttonRect );
                
        //         stickyTarget.classList.add('sticky-btn');
        //     } else if (isVisible && stickyTarget.classList.contains('sticky-btn')) {
        //         console.log('Removing sticky-btn class', buttonRect );
                
        //         stickyTarget.classList.remove('sticky-btn');
        //     }
        // }
    }
    
    
}

typeof templateProductJS !== 'undefined' && new templateProductJS();

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}


// const box = document.querySelector('[data-main-slider]');

// var stickyBtn = document.querySelector('[data-stickyBtn]');
// document.addEventListener('scroll', function () {
//     if(isInViewport(box)){
//          if(stickyBtn.classList.contains('d-block')){
//             stickyBtn.classList.remove('d-block');
//         }
//         stickyBtn.classList.add('d-none')
//     } else{
//        if(stickyBtn.classList.contains('d-none')){
//             stickyBtn.classList.remove('d-none');
//         }
//         stickyBtn.classList.add('d-block')
//     }

// }, {
//     passive: true
// });

/*************
 Google optimize A/B testing
***************/

// const experimentID = '73VQBSXXQ-iyQMjkMqnINg';
// const variation = google_optimize.get(experimentID);

// if (variation == undefined || variation == 0){
//     const box = document.querySelector('.product-add-cart');
//     var stickyBtn = document.querySelector('[data-stickyBtn]');
//     document.addEventListener('scroll', function () {
//         if(isInViewport(box)){
//             if(stickyBtn.classList.contains('d-block')){
//                 stickyBtn.classList.remove('d-block');
//             }
//             stickyBtn.classList.add('d-none')
//         } else{
//         if(stickyBtn.classList.contains('d-none')){
//                 stickyBtn.classList.remove('d-none');
//             }
//             stickyBtn.classList.add('d-block')
//         }

//     }, {
//         passive: true
//     });
// }



document.addEventListener('DOMContentLoaded', () => {
    window.productThumbsSlider = null;
    window.productMainSlider = null;

    let thumbs = null;
    if (document.querySelector('.product-thumbs-slider')) {
        thumbs = new Swiper('.product-thumbs-slider', {
            slidesPerView: 'auto',
            spaceBetween: 5,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    spaceBetween: 10
                },
            }
        });
        window.productThumbsSlider = thumbs;
    }

    const mainSliderConfig = {
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
        navigation: {
            nextEl: '.main-slide-next',
            prevEl: '.main-slide-prev',
        },
    };
    if (thumbs) {
        mainSliderConfig.thumbs = { swiper: thumbs };
    }

    const slider = new Swiper('.product-main-slider', mainSliderConfig);
    window.productMainSlider = slider;

    const mainSliderEl = document.querySelector('.product-main-slider');
    if (mainSliderEl) {
        mainSliderEl.querySelectorAll('.product--media').forEach((media) => {
            const customVideo = media.querySelector('custom-video');
            if (customVideo) {
                customVideo._onloadRennderVideo();
                const video = customVideo.querySelector('video');
                video.setAttribute('playsinline', 'true');
                video.setAttribute('muted', 'true');
                video.setAttribute('loop', 'true');
                video.setAttribute('webkit-playsinline', 'true');
            }
        });
    }

    slider.on('slideChangeTransitionEnd', (slideEvent) => {
        const slides = slideEvent.slides;
        slides.forEach((slide) => {
            const videoEle = slide.querySelector('video');
            const isActive = slide.classList.contains('swiper-slide-active');
            if (videoEle && isActive) {
                videoEle.play();
            } else if (videoEle && !isActive) {
                videoEle.pause();
            }
        });
    });
});


(function initRechargeLearnMoreColor() {
    const widget = document.querySelector('.product-details-wrapper recharge-subscription-widget');
    if (!widget) return;

    function syncState() {
        const sr = widget.shadowRoot;
        if (!sr) return;
        const onetimeSelected = sr.querySelector('[part~="rc-purchase-option__onetime"][part~="rc-purchase-option__selected"]');
        if (onetimeSelected) {
            widget.setAttribute('data-rc-selected', 'onetime');
        } else {
            widget.removeAttribute('data-rc-selected');
        }
    }

    function injectLearnMoreStyle(sr) {
        const rcLearnMore = sr.querySelector('rc-learn-more');
        if (!rcLearnMore || !rcLearnMore.shadowRoot) return false;

        const style = document.createElement('style');
        style.textContent = '@media (max-width: 480px) { :host { display: inherit !important;  margin-left: 0.3rem !important; } }';
        rcLearnMore.shadowRoot.appendChild(style);
        return true;
    }

    let observer;
    const poll = setInterval(() => {
        if (!widget.shadowRoot) return;
        clearInterval(poll);

        const sr = widget.shadowRoot;

        const learnMorePoll = setInterval(() => {
            if (injectLearnMoreStyle(sr)) clearInterval(learnMorePoll);
        }, 100);

        observer = new MutationObserver(syncState);
        observer.observe(sr, { subtree: true, attributes: true, attributeFilter: ['part', 'class'] });
        syncState();
    }, 100);
})();

(function () {
    const WIDGET_SELECTOR = 'recharge-subscription-widget';
    const OBSERVE_CONFIG = { childList: true, subtree: true, characterData: true, attributes: true };

    function extractMoneyText(text) {
      const matches = String(text).match(/\$[\d,]+(?:\.\d+)?/g);
      if (matches && matches.length) return matches[matches.length - 1];
      const amount = parseFloat(String(text).replace(/[^0-9.]/g, ''));
      if (isNaN(amount) || amount <= 0) return '';
      return Shopify.formatMoney(Math.round(amount * 100), window.globalVariables.money_format);
    }

    function getSelectedPriceText(sr) {
      const onetimeSelected = sr.querySelector('[part~="rc-purchase-option__onetime"][part~="rc-purchase-option__selected"]');
      if (onetimeSelected) {
        const onetimePriceEl = onetimeSelected.querySelector('[part~="rc-purchase-option__price"]')
          || sr.querySelector('[part~="rc-purchase-option__original-price"]');
        return extractMoneyText(onetimePriceEl ? onetimePriceEl.textContent : '');
      }

      const discountedEl = sr.querySelector('[part~="rc-purchase-option__discounted-price"]');
      return extractMoneyText(discountedEl ? discountedEl.textContent : '');
    }

    function updateCurrentPrice(sr) {
      const priceText = getSelectedPriceText(sr);
      if (!priceText) return;

      document.querySelectorAll('.product-details-wrapper [data-currentprice]').forEach((el) => {
        el.textContent = ` - ${priceText}`;
      });
    }

    function updateSubscriptionLabel(sr, observer) {
      try {
        const label = sr.querySelector('[part~="rc-purchase-option__selector_subscription"]');
        if (!label) return;

        const originalEl = sr.querySelector('[part~="rc-purchase-option__original-price"]');
        const discountedEl = sr.querySelector('[part~="rc-purchase-option__discounted-price"]');
        if (!originalEl || !discountedEl) return;

        const original = parseFloat(originalEl.textContent.replace(/[^0-9.]/g, ''));
        const discounted = parseFloat(discountedEl.textContent.replace(/[^0-9.]/g, ''));
        if (isNaN(original) || isNaN(discounted) || original <= 0 || discounted <= 0 || discounted >= original) return;

        const discount = Math.round(((original - discounted) / original) * 100);
        if (discount <= 0) return;

        const textNode = Array.from(label.childNodes).find(
          node => node.nodeType === Node.TEXT_NODE && node.textContent.includes('Subscribe')
        );
        if (!textNode) return;

        observer.disconnect();
        textNode.textContent = `Subscribe & Save ${discount}%`;
        observer.observe(sr, OBSERVE_CONFIG);
      } catch (e) {}
    }

    function initWidget(widget) {
      if (!widget) return;

      function waitForShadowRoot() {
        if (!widget.shadowRoot) { requestAnimationFrame(waitForShadowRoot); return; }
        const sr = widget.shadowRoot;
        const observer = new MutationObserver(() => {
          updateSubscriptionLabel(sr, observer);
          updateCurrentPrice(sr);
        });
        observer.observe(sr, OBSERVE_CONFIG);
        sr.addEventListener('change', (event) => {
          if (event.target && event.target.name === 'purchaseOption') {
            updateSubscriptionLabel(sr, observer);
            updateCurrentPrice(sr);
          }
        });
        updateSubscriptionLabel(sr, observer);
        updateCurrentPrice(sr);
      }

      waitForShadowRoot();
    }

    function waitForWidget() {
      const widget = document.querySelector(WIDGET_SELECTOR);
      if (widget) { initWidget(widget); } else { requestAnimationFrame(waitForWidget); }
    }

    document.addEventListener('DOMContentLoaded', waitForWidget);
})();

document.addEventListener('DOMContentLoaded', () => {
    const reviewStar = document.querySelector('.customReviews');
    const targetDiv = document.querySelector('.reviews-bg-images');
    if (reviewStar && targetDiv) {
        reviewStar.classList.add('cursor-pointer');
        reviewStar.addEventListener('click', (e) => {
            e.preventDefault();
            const navbar = document.querySelector('.navbar-main');
            const loyaltyWidget = document.querySelector('.yotpo-widget-loyalty-floater-widget');
            const offset = (navbar ? navbar.offsetHeight : 0) + (loyaltyWidget ? loyaltyWidget.offsetHeight : 0);
            const top = targetDiv.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        });
    }
});
